import { checkmarkCircleOutline, closeCircleOutline } from 'ionicons/icons';
import { ToastOptions } from '@ionic/core/components';

export const getAppError = (msg: string | null): ToastOptions => {
  return {
    message: msg || '',
    duration: 3500,
    position: 'top',
    color: 'danger',
    icon: closeCircleOutline,
  };
};

export const getAppSuccess = (msg: string | null): ToastOptions => {
  return {
    message: msg || '',
    duration: 1500,
    position: 'top',
    color: 'success',
    icon: checkmarkCircleOutline,
  };
};

export const getUserMessageOrValidationError = (
  error: any,
): string | boolean => {
  const userMessage = error?.response?.data?.userMessage || null;
  if (userMessage) {
    return userMessage;
  }
  const vError = getFirstValidationError(error);
  if (vError) {
    return vError;
  }
  return getFirstOtherError(error);
};

export const getFirstValidationError = (error: any): string | boolean => {
  const validationErrors = error?.response?.data?.validationErrors || [];
  if (validationErrors && validationErrors.length && validationErrors[0]) {
    const vError = validationErrors[0];
    if (vError.message) {
      return vError.message;
    }
  }
  return false;
};

export const getFirstOtherError = (error: any): string | boolean => {
  const errors = error?.response?.data?.Errors || [];
  if (errors && errors.length && errors[0]) {
    const oError = errors[0];
    if (oError.Message) {
      return oError.Message;
    }
  }
  return false;
};
